import { render, staticRenderFns } from "./RegisterPhone.vue?vue&type=template&id=1f36b2f6&scoped=true"
import script from "./RegisterPhone.vue?vue&type=script&lang=js"
export * from "./RegisterPhone.vue?vue&type=script&lang=js"
import style0 from "./RegisterPhone.vue?vue&type=style&index=0&id=1f36b2f6&prod&scoped=true&lang=css"
import style1 from "./RegisterPhone.vue?vue&type=style&index=1&id=1f36b2f6&prod&lang=css"
import style2 from "./RegisterPhone.vue?vue&type=style&index=2&id=1f36b2f6&prod&scoped=true&lang=css"
import style3 from "./RegisterPhone.vue?vue&type=style&index=3&id=1f36b2f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f36b2f6",
  null
  
)

export default component.exports